import React, {PureComponent} from "react"
import {isMobile,} from "react-device-detect";
import ReactDOM from "react-dom";
import {hashString} from '../../helpers/hash-string';

export class BrandLink extends PureComponent {

  constructor (props) {
    super (props)
    this.state = {
      excludedBrands : ["House by John Lewis", "John Lewis", "John Lewis & Partners", "West Yorkshire Spinners"]
    };
  }

  truncate(brandName){
    const sliced = brandName.split(' ');
    const limit = 3;
    if(sliced.length > limit) {
      return sliced.slice(0, limit).join(' ') + ' ...';
    }
    return brandName;
  }

  removeLinkScrollCacheKey(link){
    const url = location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
    const currentURLHash = hashString(url + link);
    window.localStorage.removeItem(link);
    window.sessionStorage.removeItem("plp-cache-"+currentURLHash+"-scroll");
  }

  brandLink(){
    const {brandName, brandLink, subBrandName, subBrandLink} = this.props;
    const truncatedBrandName = brandName && window.innerWidth < 600 ? this.truncate(brandName) : brandName;
    const truncatedSubBrandName = subBrandName && window.innerWidth < 600 ? this.truncate(subBrandName) : subBrandName;
    return brandName && isMobile && !this.state.excludedBrands.includes(brandName) ?
      subBrandLink ?
        (<a href={subBrandLink} onClick={()=>this.removeLinkScrollCacheKey(subBrandLink)}>Shop all {truncatedSubBrandName}</a>)
        :
        (<a href={brandLink} onClick={()=>this.removeLinkScrollCacheKey(brandLink)}>Shop all {truncatedBrandName}</a>)
      : <span></span>;
  }

  renderBrandLink(){
    const {rootElement} = this.props;
    rootElement && ReactDOM.render(
      this.brandLink(),
      rootElement);
  }

  componentDidMount() {
    window.addEventListener("resize", () => this.renderBrandLink());
  }

  render(){
    return this.brandLink();
  }
}
